import(/* webpackMode: "eager", webpackExports: ["SplashLoader"] */ "/Users/spring/mhnt/Fadhili/2025_FADHILI_MASTER_FE/src/components/Splash/index.tsx");
